(function () {
  const ATTRIBUTION_SYNC_MAX_ATTEMPT = 4;

  function marketingAllowed() {
    return window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  }

  function readCookieRaw(name) {
    const prefix = `${name}=`;
    const cookie = document.cookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith(prefix));

    return cookie ? cookie.slice(prefix.length) : undefined;
  }

  function syncAttributionToCart(attempt = 0) {
    const allowed = marketingAllowed();
    const oppref = allowed ? readCookieRaw('__oppref') : undefined;
    const obref = allowed ? readCookieRaw('__obref') : undefined;
    const attributes = {
      __openai_ads_consent: allowed ? 'granted' : '',
      __openai_oppref: oppref || '',
      __openai_obref: obref || '',
    };

    const config = typeof fetchConfig === 'function' ? fetchConfig() : {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    fetch(window.routes?.cart_update_url || `${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      ...config,
      body: JSON.stringify({ attributes }),
      keepalive: true,
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart attribution update failed');
        if (allowed && !oppref && !obref && attempt < ATTRIBUTION_SYNC_MAX_ATTEMPT) {
          window.setTimeout(() => syncAttributionToCart(attempt + 1), 500);
        }
      })
      .catch(() => {
        if (attempt < ATTRIBUTION_SYNC_MAX_ATTEMPT) {
          window.setTimeout(() => syncAttributionToCart(attempt + 1), 500);
        }
      });
  }

  window.openaiAdsSyncAttribution = function () {
    syncAttributionToCart();
  };

  window.openaiAdsMeasureItemsAdded = function (items) {
    if (!marketingAllowed() || typeof window.oaiq !== 'function') return;

    try {
      const currency = window.Shopify?.currency?.active || 'USD';
      const addedItems = Array.isArray(items) ? items : [items];
      const contents = addedItems.map((item) => {
        const amount = Number.isInteger(item.final_price) ? item.final_price : item.price;
        const quantity = Number.isInteger(item.quantity) ? item.quantity : 1;

        return {
          id: String(item.variant_id || item.id || ''),
          name: item.product_title || item.title,
          content_type: 'product',
          quantity,
          amount: Number.isInteger(amount) ? amount : undefined,
          currency,
        };
      });
      const totalAmount = contents.reduce(
        (total, item) => total + (Number.isInteger(item.amount) ? item.amount * item.quantity : 0),
        0
      );

      window.oaiq('measure', 'items_added', {
        type: 'contents',
        amount: Number.isInteger(totalAmount) ? totalAmount : undefined,
        currency,
        contents,
      });
    } catch (_) {
      // Conversion measurement must never interrupt add to cart.
    }
  };

  let bcpoCartSnapshot = window.bcpo?.cart;
  let bcpoCartSnapshotRequestSequence = 0;
  let bcpoCartMeasurementQueue = Promise.resolve();

  function cartJsonUrl() {
    return window.routes?.cart_url ? `${window.routes.cart_url}.js` : `${window.Shopify?.routes?.root || '/'}cart.js`;
  }

  function fetchCart() {
    return fetch(cartJsonUrl())
      .then((response) => {
        if (!response.ok) throw new Error('Cart lookup failed');
        return response.json();
      });
  }

  function updateBcpoCartSnapshot(cart, requestSequence) {
    if (requestSequence < bcpoCartSnapshotRequestSequence) return;

    bcpoCartSnapshot = cart;
    bcpoCartSnapshotRequestSequence = requestSequence;
  }

  function refreshBcpoCartSnapshot() {
    const requestSequence = bcpoCartSnapshotRequestSequence + 1;
    bcpoCartSnapshotRequestSequence = requestSequence;

    return fetchCart()
      .then((cart) => {
        updateBcpoCartSnapshot(cart, requestSequence);
      })
      .catch(() => {
        // Conversion measurement must never interrupt the cart experience.
      });
  }

  function measureBcpoItemsAdded() {
    const previousCart = bcpoCartSnapshot;
    const requestSequence = bcpoCartSnapshotRequestSequence + 1;
    bcpoCartSnapshotRequestSequence = requestSequence;

    return fetchCart()
      .then((cart) => {
        updateBcpoCartSnapshot(cart, requestSequence);
        if (!previousCart) return;

        const previousQuantities = new Map(
          (previousCart.items || []).map((item) => [item.key, item.quantity])
        );
        const addedItems = (cart.items || []).flatMap((item) => {
          const previousQuantity = previousQuantities.get(item.key) || 0;
          const quantity = item.quantity - previousQuantity;
          return quantity > 0 ? [{ ...item, quantity }] : [];
        });

        if (addedItems.length > 0) window.openaiAdsMeasureItemsAdded(addedItems);
      })
      .catch(() => {
        // Conversion measurement must never interrupt the cart experience.
      });
  }

  function queueBcpoItemsAddedMeasurement() {
    bcpoCartMeasurementQueue = bcpoCartMeasurementQueue
      .then(() => measureBcpoItemsAdded())
      .catch(() => {
        // Conversion measurement must never interrupt the cart experience.
      });
  }

  function attachBcpoSuccessListener(attempt = 0) {
    if (window.bcpo?.$ && !window.openaiAdsBcpoListenerAttached) {
      window.openaiAdsBcpoListenerAttached = true;
      window.bcpo.$(document).on('bcpo:afterAdd.openaiAds', function () {
        window.openaiAdsSyncAttribution();
        queueBcpoItemsAddedMeasurement();
      });
      return;
    }

    if (attempt < 120) {
      window.setTimeout(() => attachBcpoSuccessListener(attempt + 1), 250);
    }
  }

  document.addEventListener('visitorConsentCollected', (event) => {
    syncAttributionToCart();
  });

  if (window.location.pathname.includes('/products/')) {
    if (window.openaiAdsConsentTrackingReady) {
      syncAttributionToCart();
    } else {
      window.setTimeout(syncAttributionToCart, 500);
    }
    refreshBcpoCartSnapshot();
    attachBcpoSuccessListener();
  }
})();
